import { render, staticRenderFns } from "./CoPilotButton.vue?vue&type=template&id=0fcb2c8a&scoped=true"
import script from "./CoPilotButton.vue?vue&type=script&lang=js"
export * from "./CoPilotButton.vue?vue&type=script&lang=js"
import style0 from "./CoPilotButton.vue?vue&type=style&index=0&id=0fcb2c8a&prod&lang=css"
import style1 from "./CoPilotButton.vue?vue&type=style&index=1&id=0fcb2c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb2c8a",
  null
  
)

export default component.exports